import { Component, Vue, Watch } from 'vue-property-decorator';
import { onErrorImageAvatar } from '@/util/common-util';
import { IUser } from '@/shared/model/user.model';
import { UserModel } from '@/shared/model/users.model';
import {CONTENT_LANGUAGES, COUNTRIES, THEMES, USER_LANGUAGES} from '@/constants';
import UserPaidInfo from '@/v2/components/my-page/user-paid-info/user-paid-info.vue';
import UserScrapAgent from '@/v2/components/my-page/user-scrap-agent/user-scrap-agent.vue';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({
  computed: {},
  methods: { onErrorImageAvatar },
  components: {
    'user-paid-info': UserPaidInfo,
    'user-scrap-agent': UserScrapAgent,
  },
})
export default class MyPagePreview extends Vue {
  @appStoreState.Mutation
  public setIsShowPopupLogin!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupRegister!: (payload: boolean) => void;

  @appStoreState.Getter
  getCurrentUserImageUri!: string;

  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;

  user: IUser = new UserModel();
  imageUrl = 'content/images/avatar.png';
  language = '';

  get theme() {
    return THEMES.find(item => item.value == localStorage.getItem('theme'))?.text;
  }

  get contentLanguage() {
    const contentLanguages = this.account.contentLanguages?.map(item => {
      const found = CONTENT_LANGUAGES.find(lang => lang.value == item);
      return found ? found.label : item;
    });
    return contentLanguages?.join(', ');
  }

  get account() {
    return this.$store.getters.account;
  }

  get isAccountReady() {
    return !!this.account;
  }

  get isGuest() {
    return this.account?.isGuest ?? false;
  }

  mounted() {
    this.getUser();
  }

  getUser() {
    if (this.localStorageUser) {
      this.user = this.localStorageUser;
      this.imageUrl = this.localStorageUser.imageUrl ? this.localStorageUser.imageUrl : 'content/images/avatar.png';
      this.language = USER_LANGUAGES.find(item => item.value == this.user.langKey).text;
    }
  }

  goTo(destination: string) {
    this.$router.push(destination);
  }

  signUp() {
    this.setIsShowPopupRegister(true);
  }

  signIn() {
    this.setIsShowPopupLogin(true);
  }

  formatPhoneNumberToE164(phoneNumber: string, countryCode: string): string {
    if (!countryCode) return phoneNumber;

    const country = COUNTRIES.find(c => c.value === countryCode.toUpperCase());
    if (!country) return '';

    const dialCodeMatch = country.label.match(/\+[\d]+/);
    if (!dialCodeMatch) return '';

    const dialCode = dialCodeMatch[0];
    const normalizedPhone = phoneNumber.trim().replace(/^0+/, '');

    return `${dialCode}${normalizedPhone}`;
  }
}
